import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'SavedListings',
    data () {
        return {
            user: {},
            listings: {},
            listing: {},
            img_url: service.imageURL
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    methods: {
        //settings
        setPanel() {
            this.panelFlag = true
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getSavedListings() {
           let user_id = localStorage.getItem("cityneeds_token_key");
           service.getSavedListings(this, user_id).then(data => {
               if(data.body.status == 200) {
                    this.listings = data.body.data;
                    let result = data.body.data;
                    let count = 0;
                    result.forEach(function(element) {
                        ++count;
                        if(count == 1){
                            this.listing = element; 
                        }
                    }, this);
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //get all saved listing
        getSavedListing(id) {
           service.getSavedListing(this, id).then(data => {
               if(data.body.status == 200) {
                    this.listing = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        
        viewCnpro(cnpro){
           if(cnpro) {
                localStorage.setItem("cityneeds_search_cnpro", cnpro); //use local storage for now
                this.$router.push("cnpro");
                //location.assign("cnpro")
           }
            
        },

        viewBusiness(business){
           if(business) {
                localStorage.setItem("cityneeds_search_business", business); //use local storage for now
                this.$router.push("businesses");
            }
            
        },
        
    },
    created: function(){
        this.preset();
        this.getSavedListings();
    }
}


// WEBPACK FOOTER //
// ./src/components/SavedListings/script.js